import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import CallMadeRoundedIcon from '@mui/icons-material/CallMadeRounded';
import CallReceivedRoundedIcon from '@mui/icons-material/CallReceivedRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import LeaderboardRoundedIcon from '@mui/icons-material/LeaderboardRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import ListRoundedIcon from '@mui/icons-material/ListRounded';
import LocalActivityRoundedIcon from '@mui/icons-material/LocalActivityRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import PaletteRoundedIcon from '@mui/icons-material/PaletteRounded';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import SentimentSatisfiedAltRoundedIcon from '@mui/icons-material/SentimentSatisfiedAltRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { BombIcon } from '../icons/bombIcon';
import { InfoIcon } from '../icons/infoIcon';
import { DRAWER_ACCOUNT_ICON_COLOR, DRAWER_BAD_BEAT_JACKPOT_ICON_COLOR, DRAWER_GAME_INFO_ICON_COLOR, DRAWER_PLAYERS_ICON_COLOR, DRAWER_RANKINGS_ICON_COLOR, DRAWER_TOURNEYS_ICON_COLOR } from '../styles/colors';
export const ALL_EXPANDABLE_SECTION_PROPERTIES = {
    'player-bio': { label: 'Bio', svgIconComponent: SentimentSatisfiedAltRoundedIcon },
    'player-style': { label: 'Play Style', svgIconComponent: SpeedRoundedIcon },
    'player-bombs': { label: 'Bombs & Charms', svgIconComponent: BombIcon },
    'player-medals': { label: 'Medals', svgIconComponent: StarRoundedIcon },
    'player-stats': { label: 'Stats', svgIconComponent: ListAltRoundedIcon },
    'player-restricted-stats': { label: 'Restricted Stats', svgIconComponent: LockRoundedIcon },
    'self-bio': { label: 'Bio', svgIconComponent: SentimentSatisfiedAltRoundedIcon },
    'self-style': { label: 'Play Style', svgIconComponent: SpeedRoundedIcon },
    'self-bombs': { label: 'Bombs & Charms', svgIconComponent: BombIcon },
    'self-medals': { label: 'Medals', svgIconComponent: StarRoundedIcon },
    'self-tickets': { label: 'Tickets', svgIconComponent: LocalActivityRoundedIcon },
    'self-theme': { label: 'Theme', svgIconComponent: PaletteRoundedIcon },
    'self-stats': { label: 'Stats', svgIconComponent: ListAltRoundedIcon },
    'friends-online': { label: 'Friends Online', svgIconComponent: FavoriteBorderRoundedIcon },
    'admins-online': { label: 'Admins Online' },
    'helpers-online': { label: 'Helpers Online' },
    'requests-received': { label: 'Requests Received', svgIconComponent: CallReceivedRoundedIcon },
    'requests-sent': { label: 'Requests Sent', svgIconComponent: CallMadeRoundedIcon },
    'friends-all': { label: 'All Friends', svgIconComponent: ListRoundedIcon },
    'drawer-account': { label: 'Account', svgIconComponent: AccountCircleRoundedIcon, color: DRAWER_ACCOUNT_ICON_COLOR },
    'drawer-game-info': { label: 'Game Info', svgIconComponent: InfoIcon, color: DRAWER_GAME_INFO_ICON_COLOR },
    'drawer-rankings': { label: 'Rankings', svgIconComponent: LeaderboardRoundedIcon, color: DRAWER_RANKINGS_ICON_COLOR },
    'drawer-players': { label: 'Players', svgIconComponent: PeopleRoundedIcon, color: DRAWER_PLAYERS_ICON_COLOR },
    'drawer-bad-beat-jackpot': {
        label: 'Bad Beat Jackpot',
        svgIconComponent: MonetizationOnRoundedIcon,
        color: DRAWER_BAD_BEAT_JACKPOT_ICON_COLOR
    },
    'drawer-tourneys': { label: 'Tourneys', svgIconComponent: EmojiEventsRoundedIcon, color: DRAWER_TOURNEYS_ICON_COLOR }
};
export const INITIAL_EXPANDABLE_SECTION_STATES = {
    'player-bio': true,
    'player-style': false,
    'player-bombs': false,
    'player-medals': false,
    'player-stats': false,
    'player-restricted-stats': false,
    'self-bio': false,
    'self-style': false,
    'self-bombs': false,
    'self-medals': false,
    'self-tickets': false,
    'self-theme': false,
    'self-stats': false,
    'friends-online': true,
    'admins-online': true,
    'helpers-online': true,
    'requests-received': true,
    'requests-sent': true,
    'friends-all': false,
    'drawer-account': false,
    'drawer-game-info': false,
    'drawer-rankings': false,
    'drawer-players': false,
    'drawer-bad-beat-jackpot': false,
    'drawer-tourneys': false
};
